import { puzzle, status, statusLine } from "../game/state";
import { GameOverPanel, Hint, HintDisplay } from "./Hint";
import { Spaces } from "./Spaces";

/** The header area that sits between the masthead and the board.
    During play it's a 3-row layout — reveal buttons, hint display,
    status line — each with its own reserved height so individual
    purchases don't shift the board. After game-over the area collapses
    into the `<GameOverPanel />` (answer + byline + stats). */
export function TopBar() {
  const p = puzzle.value;
  const playing = status.value === "playing";

  // No puzzle yet (loading): reserve the same vertical space the
  // playing-state layout will need so the masthead and board don't
  // jump when the puzzle arrives.
  if (p == null) return <div class="topbar topbar--placeholder" aria-hidden="true" />;

  if (!playing) {
    return (
      <div class="topbar">
        <GameOverPanel />
      </div>
    );
  }

  return (
    <div class="topbar">
      <div class="reveal-buttons">
        <Spaces />
        <Hint />
      </div>
      <div class="hint-display">
        <HintDisplay />
      </div>
      <p class="status-line" aria-live="polite">
        {statusLine.value}
      </p>
    </div>
  );
}
